/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Fields/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AssignedDoctor from './AssignedDoctor/index'
import DateOfBirth from './DateOfBirth/index'
import FirstName from './FirstName/index'
import Gender from './Gender/index'
import LastName from './LastName/index'
import MiddleName from './MiddleName/index'
import React from 'react'
import Ssn from './Ssn/index'
import Title from './Title/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Fields({
  children,
  viewPath = "/App/Account/NewPatient/Content/Form/Fields"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Fields.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Fields.Vertical"
  data-view-path={viewPath}
 style={{'--pr-1-2tX3iC': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<Title
  viewPath={`${viewPath}/Title`}
/>
<FirstName
  viewPath={`${viewPath}/FirstName`}
/>
<MiddleName
  viewPath={`${viewPath}/MiddleName`}
/>
<LastName
  viewPath={`${viewPath}/LastName`}
/>
</div>
<div
  data-testid="Fields.Vertical:1"
  data-view-path={viewPath}
 style={{'--pl-2-2tX3iC': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical1}`}
>
<Gender
  viewPath={`${viewPath}/Gender`}
/>
<DateOfBirth
  viewPath={`${viewPath}/DateOfBirth`}
/>
<Ssn
  viewPath={`${viewPath}/Ssn`}
/>
<AssignedDoctor
  viewPath={`${viewPath}/AssignedDoctor`}
/>
</div>
</div>
{children}
</React.Fragment>)
}